export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/Dashboard": [6,[2]],
		"/(app)/GeneralInstructions": [7,[2]],
		"/(app)/StudentInsights/[id]": [8,[2]],
		"/(app)/StudentsManagement": [9,[2]],
		"/(app)/admin": [10,[2,3]],
		"/(app)/admin/settings": [11,[2,3]],
		"/auth": [32],
		"/auth/forgot-password": [33],
		"/auth/reset-password/[token]": [34],
		"/(app)/c/[id]": [12,[2]],
		"/(app)/disclaimers": [13,[2]],
		"/(app)/disclaimers/[id]": [14,[2]],
		"/error": [35],
		"/(app)/popup-acknowledgments": [15,[2]],
		"/(app)/popup-acknowledgments/new": [16,[2]],
		"/(app)/popups": [17,[2]],
		"/(app)/popups/[id]": [18,[2]],
		"/(app)/subscription": [19,[2]],
		"/s/[id]": [36],
		"/(app)/workspace": [20,[2,4]],
		"/(app)/workspace/documents": [21,[2,4]],
		"/(app)/workspace/models": [22,[2,4]],
		"/(app)/workspace/models/create": [23,[2,4]],
		"/(app)/workspace/models/edit": [24,[2,4]],
		"/(app)/workspace/playground": [25,[2,4]],
		"/(app)/workspace/prompts": [26,[2,4]],
		"/(app)/workspace/prompts/create": [27,[2,4]],
		"/(app)/workspace/prompts/edit": [28,[2,4]],
		"/(app)/workspace/tools": [29,[2,4]],
		"/(app)/workspace/tools/create": [30,[2,4]],
		"/(app)/workspace/tools/edit": [31,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';